<template>
  <div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      :validate-on-rule-change="false"
      size="mini"
    >
      <h6>{{ $l('INDEX.form_header_base') || '基本信息' }}</h6>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.form_label_fabricAgent') || '业务人员'"
            prop="fabricAgentCode"
          >
            <dict-select
              v-model="formData.fabricAgentCode"
              :selectedLabel.sync="formData.fabricAgentName"
              url="/master/common/dict/baseUserSelect"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              size="mini"
              filterable
              clearable
              style="width: 100%"
              disabled
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.form_label_fabricName') || '面料'"
            prop="fabricDescriptionArray"
          >
            <dict-select
              v-model="formData.fabricDescriptionArray"
              url="/digitalCenter/master/fabric/attributes/attributesSelect"
              :body="{ fabricAttrTypeEn: 'Fabric Description' }"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              :options="{ label: 'label', value: 'this' }"
              size="mini"
              filterable
              clearable
              multiple
              style="width: 100%"
              disabled
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="
              $l('INDEX.form_label_fabricContent') || '面料成分'
            "
            prop="fabricContent"
          >
            <FabricContentInput
              :fabricContent.sync="formData.fabricContent"
              :fabricContentEn.sync="formData.fabricContentEn"
              disabled
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.form_label_flowerType') || '花型'"
            prop="patternArray"
          >
            <dict-select
              v-model="formData.patternArray"
              url="/digitalCenter/master/fabric/attributes/attributesSelect"
              :body="{ fabricAttrTypeEn: 'Pattern' }"
              :placeholder="
                $l('INDEX.tips_select_data_multiple') || '请选择数据!(可多选)'
              "
              :options="{ label: 'label', value: 'this' }"
              size="mini"
              filterable
              clearable
              multiple
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('INDEX.form_label_technology') || '工艺'">
            <dict-select
              v-model="formData.techniqueArray"
              url="/digitalCenter/master/fabric/attributes/attributesSelect"
              :body="{ fabricAttrTypeEn: 'Technique' }"
              :placeholder="
                $l('INDEX.tips_select_data_multiple') || '请选择数据!(可多选)'
              "
              :options="{ label: 'label', value: 'this' }"
              size="mini"
              filterable
              clearable
              multiple
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('INDEX.form_label_function') || '功能'">
            <dict-select
              v-model="formData.functionArray"
              url="/digitalCenter/master/fabric/attributes/attributesSelect"
              :body="{ fabricAttrTypeEn: 'Function' }"
              :placeholder="
                $l('INDEX.tips_select_data_multiple') || '请选择数据!(可多选)'
              "
              :options="{ label: 'label', value: 'this' }"
              size="mini"
              filterable
              clearable
              multiple
              style="width: 100%"
              disabled
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.form_label_materialAttribute') || '原料属性'"
          >
            <el-input
              v-model="formData.materialAttribute"
              :placeholder="
                $l('INDEX.tips_input_placeholder_materialAttribute') ||
                  '请输入原料属性'
              "
              style="width: 100%"
              maxLength="500"
              clearable
              disabled
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="3">
          <el-form-item
            :label="$l('INDEX.form_label_fabric_width') || '有效门幅'"
            prop="wid"
          >
            <el-input-number
              v-model="formData.wid"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              :min="0"
              :max="999999.99"
              :precision="2"
              :controls="false"
              style="width:100%"
              v-el-inputnumber-default0
            />
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item
            :label="$l('INDEX.form_label_doorWidthUnit') || '门幅单位'"
            prop="widUnit"
          >
            <dict-select
              v-model="formData.widUnit"
              url="/digitalCenter/common/dict/biz"
              :body="{ dictType: 'widUnit' }"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              size="mini"
              filterable
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item
            :label="$l('INDEX.form_label_fabricWeight') || '面料克重'"
            prop="fabricWeight"
          >
            <el-input-number
              v-model="formData.fabricWeight"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              :min="0"
              :precision="2"
              :controls="false"
              style="width:100%"
              disabled
            />
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item
            :label="$l('INDEX.form_label_fabricWeightUnit') || '克重单位'"
            prop="fabricWeightUnit"
          >
            <dict-select
              v-model="formData.fabricWeightUnit"
              url="/digitalCenter/common/dict/biz"
              :body="{ dictType: 'fabricWeightUnit' }"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              size="mini"
              filterable
              clearable
              disabled
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('INDEX.form_label_density') || '密度'">
            <el-input
              v-model="formData.density"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              maxlength="50"
              clearable
              disabled
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('INDEX.form_label_yarnWeaving') || '纱织'">
            <el-input
              v-model="formData.yarnCount"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              maxlength="50"
              clearable
              disabled
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="3">
          <el-form-item :label="$l('INDEX.form_label_unitPrice') || '参考单价'">
            <el-input-number
              v-model="formData.unitPrice"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              :min="0"
              :max="99999999.99"
              :precision="2"
              :controls="false"
              style="width:100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item
            :label="$l('INDEX.form_label_fabricUnit') || '面料单位'"
            prop="fabricUnit"
          >
            <dict-select
              v-model="formData.fabricUnit"
              url="/digitalCenter/common/dict/biz"
              :body="{ dictType: 'fabricYarnUnit' }"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              size="mini"
              filterable
              clearable
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item
            :label="$l('INDEX.form_label_startingOrder') || '起订量'"
          >
            <el-input-number
              v-model="formData.moq"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              :min="0"
              :max="999999999"
              :precision="0"
              :controls="false"
              style="width:100%"
              v-el-inputnumber-default0
            />
          </el-form-item>
        </el-col>
        <el-col :span="9">
          <el-form-item
            :label="$l('INDEX.form_label_supplier') || '供应商'"
            prop="supCode"
          >
            <dict-select
              v-model="formData.supCode"
              url="/master/common/dict/scm"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              size="mini"
              filterable
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.form_label_factoryNumber') || '工厂面料编号'"
            prop="factoryNumber"
          >
            <el-input
              v-model.trim="formData.factoryNumber"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              maxlength="50"
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item
            :label="$l('INDEX.form_label_fabricMemo') || '备注（风险提示）'"
          >
            <el-input
              v-model="formData.fabricMemo"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              maxlength="500"
              type="textarea"
              show-word-limit
              clearable
              :autosize="{ minRows: 3, maxRows: 5 }"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import FabricContentInput from '@/views/ecom/components/fabric-content-input'
export default {
  mixins: [EditLoading],
  components: { FabricContentInput },
  props: {
    fabricCode: { type: String, default: '' },
    fabricSeriesCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    isCopy: { type: Boolean, default: false },
    form: { type: Object, default: () => {} },
  },
  data() {
    return {
      formData: {
        fabricAgentCode: '',
        fabricAgentName: '',
        fabricUseStatus: 'N',
        wid: 0,
        widUnit: 'cm',
      },
    }
  },
  computed: {
    ...mapState('admin/user', { userInfo: 'info' }),
    isTulip() {
      const { supCode } = this.formData
      // 判断是否是【苏州合祥纺织科技有限公司】
      return supCode === 'e667dc86-dfb9-11e7-807f-f0def1247d1f'
    },
    rules() {
      return {
        fabricAgentCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        fabricDescriptionArray: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        fabricContent: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'blur',
          },
        ],
        patternArray: [
          {
            required: true,
            message:
              this.$l('INDEX.tips_select_data_multiple') ||
              '请选择数据!(可多选)',
            trigger: 'change',
          },
        ],
        // wid: [
        //   {
        //     required: true,
        //     message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
        //     trigger: 'blur',
        //   },
        // ],
        // widUnit: [
        //   {
        //     required: true,
        //     message: this.$l('INDEX.tips_select_data') || '请选择...',
        //     trigger: 'change',
        //   },
        // ],
        fabricWeight: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
        fabricWeightUnit: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        unitPrice: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
        fabricUnit: [
          {
            required: this.formData.unitPrice,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        supCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        factoryNumber: [
          {
            required: this.isTulip,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
      }
    },
  },
  watch: {
    userInfo: {
      handler() {
        if (this.fabricCode) return
        if (!this.userInfo) return
        const { userCode, userName, userNameEn } = this.userInfo || {}
        this.formData.fabricAgentCode = userCode || ''
        this.formData.fabricAgentName = [userNameEn, userName]
          .filter(Boolean)
          .join('-')
      },
      immediate: true,
    },
    form: {
      handler(newVal) {
        if (!newVal || this.isCopy) return

        const {
          fabricSeriesCode,
          fabricAgentCode,
          fabricAgentName,
          fabricDescriptionArray,
          fabricContent,
          fabricContentEn,
          techniqueArray,
          functionArray,
          materialAttribute,
          fabricWeight,
          fabricWeightUnit,
          density,
          yarnCount,
        } = newVal

        this.formData = {
          ...this.formData,
          fabricSeriesCode,
          fabricAgentCode,
          fabricAgentName,
          fabricDescriptionArray,
          fabricContent,
          fabricContentEn,
          techniqueArray,
          functionArray,
          materialAttribute,
          fabricWeight,
          fabricWeightUnit,
          density,
          yarnCount,
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData({ copied = false } = {}) {
      if (!this.fabricCode) return
      const data = await this.$api
        .masterFabric_detail({ fabricCode: this.fabricCode })
        .then((res) => res.body)
        .catch(() => null)
      if (!data) return
      this.formData = data
      if (this.isCopy && !copied) {
        this.formData.fabricCode = ''
        this.formData.fabricNo = ''
        this.formData.createBy = ''
        this.formData.createDate = ''
        this.formData.createByName = ''
        this.formData.modifyBy = ''
        this.formData.modifyDate = ''
        this.formData.modifyByName = ''
        this.formData.fabricStatus = ''
        this.formData.v_fabricStatus = ''
        this.formData.defaultImageUrl = ''
        this.formData.defaultImageCode = ''
      }
      this.formData.copied = copied
      this.$emit('loaded', this.formData)
    },
    async reload() {
      if (!this.fabricCode) return
      const data = await this.$api
        .masterFabric_detail({ fabricCode: this.fabricCode })
        .then((res) => res.body)
        .catch(() => null)
      if (!data) return
      this.$emit('loaded', data)
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return

      if (this.loadingOpen()) return
      this.formData.fabricSeriesCode = this.fabricSeriesCode || ''
      const res = await this.$api
        .masterFabricEcomSave(this.formData)
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status, body } = res
      if (status !== 200 || !body) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })
      const { fabricCode, fabricNo } = body

      if (this.fabricSeriesCode) {
        this.fabricCode = fabricCode
        this.getData({ copied: true })
        return
      }

      if (this.fabricCode && !this.isCopy) return this.getData()

      this.$router.replace({
        name: 'ecom-awsSample-fabric-detail',
        params: { fabricCode, pageType: 'edit' },
        query: { fabricNo },
      })
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .el-input-number .el-input__inner {
    text-align: start;
  }
}
</style>
